import { IconButton } from "@mui/material";
import React from "react";
import { getSectionIcon } from "components/ai-editor/Section";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { addDoc, collection } from "firebase/firestore";
import { db } from "firebaseApp";
import toast from "react-hot-toast";
import { useTheme } from "@emotion/react";


export function getSectionIndex(previousSection, nextSection) {
  console.log(previousSection, nextSection);
  if(!previousSection && !nextSection) {
    return 0;
  }
  if(!previousSection) {
    return nextSection.index - 1;
  }
  if(!nextSection) {
    return previousSection.index + 1;
  }
  const mid = (previousSection.index + nextSection.index) / 2.0;
  console.log(mid); 
  return (previousSection.index + nextSection.index) / 2.0;
}

export default function AddSectionButton({ documentId, type, previousSection, nextSection, callback = () => {} }) {

  const theme = useTheme();
  const auth = useAuth();
  const uid = auth.currentUser?.uid;

  const createSection = (type) => async () => {
    try {
      const data = {
        type: type.key,
        index: getSectionIndex(previousSection, nextSection),
        uid,
        documentId,
        ...type.default,
      };
      await addDoc(collection(db, "documents", documentId, "sections"), data);
      callback();
    } catch(error) {
      console.log(error);
      toast.error("Couldn't create section.")
    }
    
  };

  return (
    <IconButton
      onClick={createSection(type)}
      sx={{
        color: theme.palette.text.main,
      }}
    >
      {getSectionIcon(type.key)}
    </IconButton>
  );

}
